import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";

export const BrandService = {
  async createBrandVoice(
    brandDetails: any,
    userId: any
  ): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/createBrandVoice`,
      {
        brand_details: brandDetails,
        user_id: parseInt(userId),
      }
    );
    return res;
  },
async updateBrandVoice(
id: number,
userId: number,
brandDetails: string,
filename: string
): Promise<AxiosResponse> {
const res = await httpClient.put<AxiosResponse>(
`${apiRoutePrefix}/updateBrandVoice`,
{
id,
user_id: userId,
brandDetails,
filename,
}
);
return res;
},

async createBrandCategoryVoice(
selectedCategory: any,
user_id: any,
category_title: any,
category_details: any,
filename: any // ➕ added
): Promise<AxiosResponse> {
const res = await httpClient.post<AxiosResponse>(
`${apiRoutePrefix}/createBrandCategoryVoice`,
{
id: selectedCategory,
user_id,
category_title,
category_details,
filename // ➕ added
    }
);
return res;
},

async updateBrandCategoryVoice(
id: number,
user_id: number,
category_title: string,
category_details: string,
filename: string
): Promise<AxiosResponse> {
return await httpClient.put<AxiosResponse>(
`${apiRoutePrefix}/updateBrandCategoryVoice`,
{
id,
user_id,
category_title,
category_details,
filename,
}
);
},

  async getBrandVoices(userId: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getBrandVoices`,
      {
        user_id: parseInt(userId),
      }
    );
    return res;
  },
  async getAllBrandCategoryVoices(userId: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/getAllBrandCategoryVoices`,
      {
        user_id: parseInt(userId),
      }
    );
    return res;
  },
  async deleteBrandCategoryVoice(id: any): Promise<AxiosResponse> {
    const res = await httpClient.delete<AxiosResponse>(
      `${apiRoutePrefix}/deleteBrandCategoryVoice/${id}`
    );
    return res;
  },
};
